import comment from './comment'
import post from './post'
import postCategory from './post-category'
import tag from './tag'
import area from './area'
import page from './page'

export default {
  name: 'Blog',
  path: 'blog',
  meta: {
    label: 'blog',
    auth: 'blog'
  },
  component: {
    name: 'Blog',
    render(c) {
      return c('router-view')
    }
  },
  children: [post, comment, postCategory, tag, area, page]
}
